import React, { useContext, useState } from "react";
import { useEffect } from "react";
import Application from "../../components/application";
import GridView from "../../components/views/gridView";
import useRelatoriosState from "../../hooks/useRelatorios";
import ModalRelatorioAdd from "./modalRelatorioAdd";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Button, Fab, Tooltip } from "@mui/material";
import TELAS from "../../constants/telas";
import TELA_ACOES from "../../constants/telaAcoes";
import permissaoTelas from "../../utils/permissaoTelas";
import { AuthContext } from "../../contexts/auth";
import { Navigate } from "react-router-dom";

const PAGINA = {
    aplicacao: 'SisPalo - Gestor',
    funcionalidade: 'Gestor',
    tela: TELAS.AGENDA_RELATORIOS,
    acoes: [TELA_ACOES.Consultar,TELA_ACOES.Imprimir, TELA_ACOES.Incluir]
}

const Relatorios = () => {

    const states = useRelatoriosState()
    const [openModalAdd, setOpenModalAdd] = useState(0);   
    const {permissaoUsuario} = useContext(AuthContext);


    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)) {
            if (states.pesquisa.value === ''){
                states.submit.set()
            }
        }
        else{
            Navigate('/gestor/dashboard');
            return;
        }
    }, [states.pesquisa.value])

    const onGerar = async (data) => {
        await states.gerarRelatorio.set(data)
        setOpenModalAdd(0)

    }    

   
    const columns = [
        {field:'nome', headerName:'Descrição Relatório', flex: 1},
        {field:'tipo_relatorio', headerName:'Tipo Relatório', flex: 1},       
        {field:'data_inicial', headerName:'Período Incial', width: 150},
        {field:'data_final', headerName:'Período Final', width: 150},
        {field:'data_agendamento', headerName:'Agendado', width: 150},        
        {field:'data_exportacao', headerName:'Gerado', width: 150},
        {field:'', headerName:'Status', width: 150, renderCell: (cellValues) => {
            const status = cellValues.row.link_arquivo ? 'Finalizado' : 'Processando';
            const color = cellValues.row.link_arquivo ? 'success' : 'warning'; // Define a cor
            return (
              <Fab
                variant="extended"
                size="small" 
                color={color}
                sx={{padding: '8px 10px', fontSize: '13px', height: '22px', zIndex: 0, position: 'absolute', 
                }}
              >
                {status}
              </Fab>
            )
        }},  
        {filed:'', headerName:'Ações', width:110, renderCell: (cellValues) =>{
            return (
                <>
                    <Tooltip title="Download Planilha" placement="bottom" arrow>
                            <Button 
                            onClick={() => {
                                const url = cellValues?.row?.link_arquivo;
                                if (url) {
                                    const filename = url.split('/').pop(); // extrai o nome do arquivo da URL
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', filename); // usa o nome real
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }
                            }} 
                                sx={{width:'55px', padding: 0,minWidth:0}}
                                disabled={!cellValues?.row?.link_arquivo || !permissaoTelas(permissaoUsuario, TELA_ACOES.Imprimir, PAGINA)}
                                ><CloudDownloadIcon/>
                            </Button>
                    </Tooltip>                
                </>
                
            )
        }}


    ]

    return (
   
        <Application>
            <> 
                <GridView 
                    title='Relatórios Agendados' 
                    states={states}
                    rows={states.registros.value}
                    columns={columns}
                    urlAdd={null}
                    urlVoltar={'/gestor/dashboard'}                    
                    onClickPesquisa={()=>{states.submit.set()}}
                    nomeItem='Relatorio'
                    children={null}
                    modalAdd={permissaoTelas(permissaoUsuario, TELA_ACOES.Incluir, PAGINA) ? () => setOpenModalAdd(1) : null}
                />
                <ModalRelatorioAdd open={openModalAdd > 0} onClose={() => setOpenModalAdd(0)} onGerar={onGerar}/>        
            </>
        </Application>
    )
}

export default Relatorios;
